import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { Avatar, AvatarFallback } from "./ui/avatar";
import { Button } from "./ui/button"; // Assuming you already have a shared Button component

export function GoogleReviews() {
  const reviews = [
    {
      name: "Sarah Johnson",
      initials: "SJ",
      rating: 5,
      date: "2 weeks ago",
      text: "BugBuddies solved our bedbug problem completely! The technician was professional, explained everything clearly, and the treatment was very effective. Free inspection was genuinely thorough. Highly recommended!",
    },
    {
      name: "Mike Rodriguez",
      initials: "MR",
      rating: 5,
      date: "1 month ago",
      text: "Had a serious cockroach issue in my kitchen. BugBuddies team came out the same day for the free inspection and started treatment immediately. No more roaches and the satisfaction guarantee gave me peace of mind.",
    },
    {
      name: "Emily Chen",
      initials: "EC",
      rating: 5,
      date: "3 weeks ago",
      text: "Excellent rodent control service! They sealed all the entry points and used humane methods. The technicians were knowledgeable and respectful of our property. The motto is true - the mice couldn't hide from these experts!",
    },
  ];

  const averageRating = 5.0;
  const totalReviews = 127;

  return (
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              What Our Customers Say
            </h2>
            <div className="flex items-center justify-center gap-2 mb-4">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                    <Star
                        key={i}
                        className="h-6 w-6 text-yellow-400 fill-current"
                    />
                ))}
              </div>
              <span className="text-xl font-semibold text-gray-900">
              {averageRating}
            </span>
              <span className="text-gray-600">
              ({totalReviews} Google Reviews)
            </span>
            </div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Don't just take our word for it - see what our
              satisfied customers have to say about our pest
              control services.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {reviews.map((review, index) => (
                <Card key={index} className="h-full">
                  <CardContent className="p-6">
                    <div className="flex items-center mb-4">
                      <Avatar className="h-10 w-10 mr-3">
                        <AvatarFallback className="bg-green-100 text-green-600">
                          {review.initials}
                        </AvatarFallback>
                      </Avatar>
                      <div>
                        <h4 className="font-semibold text-gray-900">
                          {review.name}
                        </h4>
                        <p className="text-sm text-gray-500">
                          {review.date}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center mb-3">
                      {[...Array(review.rating)].map((_, i) => (
                          <Star
                              key={i}
                              className="h-4 w-4 text-yellow-400 fill-current"
                          />
                      ))}
                    </div>

                    <Quote className="h-4 w-4 text-gray-400 mb-2" />
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {review.text}
                    </p>
                  </CardContent>
                </Card>
            ))}
          </div>

          <div className="text-center">
            <Button
                asChild
                className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg text-lg font-semibold shadow-md"
            >
              <a
                  href="https://g.page/r/CV1OYgG3ltJ3EBM/review"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                Write a Review
              </a>
            </Button>
          </div>
        </div>
      </section>
  );
}
